import { useState } from 'react';
import { Page, Button, Card, Select, InlineStack, BlockStack } from '@shopify/polaris';
import { usePaginatedResource } from '../../../shared/hooks/usePaginatedResource';
import { ErrorBanner } from '../../../shared/components/ErrorBanner';
import { DataTable } from '../../../shared/components/DataTable';
import { listWebhookLogs } from './api';
import { webhookLogToRow } from './WebhookLogRow';

const TOPIC_OPTIONS = [
  { label: 'All', value: '' },
  { label: 'orders/paid', value: 'orders/paid' },
  { label: 'app/uninstalled', value: 'app/uninstalled' },
  { label: 'shop/redact', value: 'shop/redact' },
  { label: 'customers/redact', value: 'customers/redact' },
  { label: 'customers/data_request', value: 'customers/data_request' },
];

const COLUMNS = [
  { id: 'topic', title: 'Topic' },
  { id: 'shop', title: 'Shop' },
  { id: 'order', title: 'Order ID' },
  { id: 'received', title: 'Received at' },
  { id: 'processed', title: 'Processed at' },
  { id: 'status', title: 'Status' },
];

export function WebhookLogPage(): JSX.Element {
  const [topic, setTopic] = useState('');
  const { items, loading, error, hasMore, loadMore } = usePaginatedResource(
    ['webhook-logs', topic],
    (api, cursor) => listWebhookLogs(api, { cursor, limit: 50, topic: topic || undefined }),
  );

  return (
    <Page title="Webhook log" subtitle="Shopify webhook delivery audit">
      <BlockStack gap="400">
        {error ? <ErrorBanner error={error} /> : null}
        <Card>
          <Select
            label="Topic filter"
            options={TOPIC_OPTIONS}
            value={topic}
            onChange={setTopic}
          />
        </Card>
        <DataTable
          columns={COLUMNS}
          rows={items.map(webhookLogToRow)}
          loading={loading && items.length === 0}
          resourceName={{ singular: 'webhook', plural: 'webhooks' }}
          emptyState={{ heading: 'No webhooks received' }}
        />
        {hasMore ? (
          <InlineStack align="center">
            <Button onClick={loadMore} loading={loading}>Load more</Button>
          </InlineStack>
        ) : null}
      </BlockStack>
    </Page>
  );
}
